import { useState } from 'react'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { useSelectedItemsList } from 'contexts/SelectedItemsListProvider'
import { useNicheMutations } from 'hooks-queries/niche'
import { useTranslate } from 'lib/tolgee'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

import { GROUP_NICHES_LOG } from './group-niches-form.consts'
import type { IGroupNichesForm, IGroupNichesFormBase } from './group-niches-form.types'

export const useGroupNichesFormModel = ({ handleClose }: IGroupNichesForm): IGroupNichesFormBase => {
  const [isConfirmView, setIsConfirmView] = useState(false)
  const [nicheTitle, setNicheTitle] = useState('')

  const { selectedItemsBar } = useSelectedItemsList()
  const { createToast } = useToast()
  const t = useTranslate()

  const [groupNiches, { loading }] = useNicheMutations({
    mutationName: 'groupNiches',
    errorLog: GROUP_NICHES_LOG,
  })

  const handleChange: React.ChangeEventHandler<HTMLInputElement> &
    React.ChangeEventHandler<HTMLTextAreaElement> = e => {
    const value = e.target.value
    setNicheTitle(value)
  }

  const handleViewConfirmation = () => {
    setIsConfirmView(true)
  }

  const handleSubmit = () => {
    const territoryIds = selectedItemsBar.map(niche => `niche.${niche.id}`)
    const nicheTitles = selectedItemsBar.map(item => item.name)

    const { NICHE_EDITING } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(NICHE_EDITING.GROUP_NICHES, {
      'New Niche Name': nicheTitle,
      nicheIds: territoryIds,
      'Niche Names': nicheTitles.join(', '),
    })

    groupNiches({
      variables: {
        input: {
          newName: nicheTitle,
          territoryIds: territoryIds,
        },
      },
    })
      .then(data => {
        const hasNewId = data?.data?.createMergedNiche?.newNiche?.territoryId
        if (hasNewId) {
          handleClose()
          window.location.reload()
        }
      })
      .catch(() => {
        createToast({
          content: t(TOLGEE_GLOBALS.somethingWentWrong),
        })
      })
      .finally(() => {
        handleClose()
      })
  }

  const isSubmitButtonDisabled = !nicheTitle || selectedItemsBar.length < 2

  const handleCancel = () => {
    const { NICHE_EDITING } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(NICHE_EDITING.CLOSE_MODAL)

    handleClose()
  }

  return {
    nicheTitle,
    handleChange,
    handleSubmit,
    nicheList: selectedItemsBar,
    isSubmitButtonDisabled,
    isConfirmView,
    handleViewConfirmation,
    isMutationLoading: loading,
    handleCancel,
  }
}
